/**
 * Shared body scroll lock for any overlay that hides page scroll while open.
 *
 * Saves and restores the previous inline overflow rather than resetting it, so an
 * overlay cannot discard what another script set.
 *
 * Ownership is a Set, not a depth counter: setDrawer(false) runs on every link
 * click and on the desktop resize whether or not the drawer was open, which would
 * send a counter negative. Pass the overlay element as the owner so two instances
 * cannot release each other's lock.
 */

const owners = new Set();
let saved = '';

export function setScrollLock(owner, locked) {
	const wasLocked = owners.size > 0;

	if (locked) {
		owners.add(owner);
	} else {
		owners.delete(owner);
	}

	const isLocked = owners.size > 0;

	if (!wasLocked && isLocked) {
		saved = document.body.style.overflow;
		document.body.style.overflow = 'hidden';
	} else if (wasLocked && !isLocked) {
		document.body.style.overflow = saved;
		saved = '';
	}
}
